import React from 'react';

export default {
  width: 17,
  height: 15,
  content: (
    <path d="M2.977 6.41l1.982.27a5 5 0 1 0 1.594-3.03L5.205 2.173a7 7 0 1 1-2.23 4.24zM3.343 4.01l4.261 4.315-7.22.968z" />
  )
};
